// NOTE: 3005 and 3007 are reserved for stripe webhooks and backend websocket requests respectively
const defaultPortByApiName = {
  auth: 3002,
  user: 3003,
  'mogen-orchestration': 3004,
  websocket: 3006,
  labeler: 3008,
  'external-mogen': 3009,
} as const;

type possiblePorts = typeof defaultPortByApiName;

export type ApiTypes = keyof possiblePorts;

export function getApiDomain(apiType: ApiTypes) {
  const env = import.meta.env.VITE_API_DISAMBIGUATOR ?? '';
  if (env === 'localhost') {
    const protocol = apiType === 'websocket' ? 'ws://' : 'http://';
    return `${protocol}localhost:${defaultPortByApiName[apiType]}`;
  }

  // Applets Vite dev server proxies this path to external-mogen (see vite.config).
  // Browser calls stay same-origin and avoid CORS on PUT/OPTIONS preflight.
  if (
    apiType === 'external-mogen' &&
    import.meta.env.DEV &&
    import.meta.env.VITE_EXTERNAL_MOGEN_DEV_PROXY === 'true'
  ) {
    return '/external-mogen-proxy';
  }

  const protocol = apiType === 'websocket' ? 'wss://' : 'https://';
  return `${protocol}${apiType}${env}.api.getcartwheel.com`;
}

// Helper for JSON & Plain-Text mixed responses
export function processResponseText(responseText: string) {
  try {
    return JSON.parse(responseText);
  } catch (err) {
    return responseText;
  }
}

export function notEmpty<T>(value: T | null | undefined): value is T {
  return value !== null && value !== undefined;
}
